import { render, staticRenderFns } from "./WorkReference.vue?vue&type=template&id=44466296&"
import script from "./WorkReference.vue?vue&type=script&lang=js&"
export * from "./WorkReference.vue?vue&type=script&lang=js&"
import style0 from "./WorkReference.vue?vue&type=style&index=0&id=44466296&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports